export const LOAD_SEARCH_RESULTS_BEGIN = 'LOAD_SEARCH_RESULTS_BEGIN';
export const LOAD_SEARCH_RESULTS_ERROR = 'LOAD_SEARCH_RESULTS_ERROR';
export const LOAD_SEARCH_RESULTS_SUCCESS = 'LOAD_SEARCH_RESULTS_SUCCESS';

export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE';
